<template>
  <v-container fluid>

    <!-- Carrousel -->
    <v-layout>
      <v-flex xs12>
        <v-carousel
                hide-delimiters
                height="auto"
        >
          <v-carousel-item>
            <v-img
                    :src="require('../assets/veloshop.ca_Quebec__1551459849_76.67.188.141.jpg')">
            </v-img>
          </v-carousel-item>
          <v-carousel-item>
            <v-img
                    :src="require('../assets/veloshop.ca_technicien1__1551460933_76.67.188.141.jpg')">
            </v-img>
          </v-carousel-item>
          <v-carousel-item>
            <v-img
                    :src="require('../assets/veloshop.ca_Mobile__1551459935_76.67.188.141.jpg')">
            </v-img>
          </v-carousel-item>
          <v-carousel-item>
            <v-img
                    :src="require('../assets/veloshop.ca_MSA1__1551460476_76.67.188.141.jpg')">
            </v-img>
          </v-carousel-item>
          <v-carousel-item>
            <v-img
                    :src="require('../assets/veloshop.ca_Quebec1__1551460537_76.67.188.141.jpg')">
            </v-img>
          </v-carousel-item>
          <v-carousel-item>
            <v-img
                    :src="require('../assets/veloshop.ca_Mobile3__1551460672_76.67.188.141.jpg')">
            </v-img>
          </v-carousel-item>
        </v-carousel>
      </v-flex>
    </v-layout>

    <v-divider></v-divider>

    <!-- Comment ça fonctionne ? -->
    <v-container fluid grid-list-md text-xs-center class="grey darken-4">

      <v-layout justify-center>
        <v-flex xs12>
          <h2 class="text-uppercase white--text">Comment ça fonctionne ?</h2>
        </v-flex>
      </v-layout>

      <v-divider ></v-divider>

      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-container grid-list-md text-xs-center>
            <v-layout row wrap justify-center>

              <v-flex>
                <v-card class="grey darken-4">
                  <v-card-title>
                    <v-layout justify-center>
                      <v-avatar color="#009688" size="100px">
                        <v-icon x-large class="white--text">fas fa-calendar-alt</v-icon>
                      </v-avatar>
                    </v-layout>
                  </v-card-title>
                  <v-card-text>
                    <h1 class="white--text">Réservez</h1>
                    <p class="white--text">Prenez
                      rendez-vous </br>
                      par téléphone ou </br>
                      en ligne!
                    </p>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex class="hidden-xs-only">
                <v-layout justify-center align-center>
                  <v-icon x-large class="white--text icon-next">fas fa-chevron-circle-right</v-icon>
                </v-layout>
              </v-flex>

              <v-flex>
                <v-card class="grey darken-4">
                  <v-card-title>
                    <v-layout justify-center>
                      <v-avatar color="#009688" size="100px">
                        <v-icon x-large class="white--text">fas fa-cogs</v-icon>
                      </v-avatar>
                    </v-layout>
                  </v-card-title>
                  <v-card-text>
                    <h1 class="white--text">Réparation</h1>
                    <p class="white--text">Véloshop.ca</br>
                      se déplace à vous </br>
                      pour réparer votre vélo!
                    </p>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex class="hidden-xs-only">
                <v-layout justify-center align-center>
                  <v-icon x-large class="white--text icon-next">fas fa-chevron-circle-right</v-icon>
                </v-layout>
              </v-flex>

              <v-flex>
                <v-card class="grey darken-4">
                  <v-card-title>
                    <v-layout justify-center>
                      <v-avatar color="#009688" size="100px">
                        <v-icon x-large class="white--text">fas fa-bicycle</v-icon>
                      </v-avatar>
                    </v-layout>
                  </v-card-title>
                  <v-card-text>
                    <h1 class="white--text">Roulez</h1>
                    <p class="white--text">Votre vélo est enfin</br>
                       prêt à retourner  </br>
                      sur les routes!
                    </p>
                  </v-card-text>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider></v-divider>

    <!-- Notre équipe -->
    <v-container fluid grid-list-md text-xs-center id="Equipe">
      <v-layout justify-center>
        <v-flex xs12>
          <h2 class="text-uppercase">Notre équipe</h2>
          <v-divider inset></v-divider>
        </v-flex>
      </v-layout>
      <v-layout justify-center>
        <v-flex xs12 class="hidden-xs-only">
          <h3>
            Une équipe dévouée, qui cherche toujours à offrir au client la meilleure expérience possible.</br>
            Pour nous, il est naturel de votre accompagner ainsi que de vous conseiller afin </br>
            que vous choisissiez l’entretien de vélo qui convient le mieux à vos besoins.</br>
            Notre équipe est là pour vous, avec vous, chez vous!
          </h3>
        </v-flex>
        <!-- Mobile -->
        <v-flex xs12 class="hidden-sm-and-up">
          <h3>
            Une équipe dévouée, qui cherche toujours à offrir au client la meilleure expérience possible.
            Pour nous, il est naturel de votre accompagner ainsi que de vous conseiller afin
            que vous choisissiez l’entretien de vélo qui convient le mieux à vos besoins.
            Notre équipe est là pour vous, avec vous, chez vous!
          </h3>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-container grid-list-md text-xs-center>
            <v-layout row wrap justify-center>

              <v-flex>
                <v-card elevation="0">
                  <v-card-title>
                    <v-layout justify-center>
                      <v-avatar color="#009688" size="200px">
                        <v-img :src="require('../assets/veloshop.ca_technicien_Anthony.jpg')"></v-img>
                      </v-avatar>
                    </v-layout>
                  </v-card-title>
                  <v-card-text class="hidden-sm-and-up">
                    <h1>Anthony</h1>
                    <p>Technicien - </br>
                      Étant passionné de Freestyle,
                      Anthony pratique plusieurs sports tels
                      que le BMX et le Motocross.
                      Avec sa grande connaissance dans le domaine,
                      votre expérience sera des plus satisfaisantes.
                    </p>
                  </v-card-text>
                  <!-- Mobile -->
                  <v-card-text class="hidden-xs-only">
                    <h1>Anthony</h1>
                    <p>Technicien - </br>
                      Étant passionné de Freestyle, Anthony pratique </br>
                      plusieurs sports tels que le BMX et le Motocross.</br>
                      Avec sa grande connaissance dans le domaine,</br>
                      votre expérience sera des plus satisfaisantes.</br>
                    </p>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex>
                <v-card elevation="0">
                  <v-card-title>
                    <v-layout justify-center>
                      <v-avatar color="#009688" size="200px">
                        <v-img :src="require('../assets/veloshop.ca_technicien_Mike.jpg')"></v-img>
                      </v-avatar>
                    </v-layout>
                  </v-card-title>
                  <v-card-text class="hidden-sm-and-up">
                    <h1>Mike</h1>
                    <p>Technicien - </br>
                      Passionné de vélo depuis le plus jeune âge,
                      Mike sera en mesure de faire les mises au point
                      nécessaires en vous transmettant
                      la passion qu’il a pour son sport.
                    </p>
                  </v-card-text>
                  <!-- Mobile -->
                  <v-card-text class="hidden-xs-only">
                    <h1>Mike</h1>
                    <p>Technicien - </br>
                      Passionné de vélo depuis le plus jeune âge,</br>
                      Mike sera en mesure de faire les mises au point</br>
                      nécessaires en vous transmettant</br>
                      la passion qu’il a pour son sport.</br>
                    </p>
                  </v-card-text>
                </v-card>
              </v-flex>

              <!--<v-flex>
                <v-card elevation="0">
                  <v-card-title>
                    <v-layout justify-center>
                      <v-avatar color="#009688" size="200px">
                        <v-img :src="require('../assets/veloshop.ca_proprietaire_Alex.png')"></v-img>
                      </v-avatar>
                      </v-avatar>
                    </v-layout>
                  </v-card-title>
                  <v-card-text>
                    <h1>Alex</h1>
                    <p>Propriétaire - </br>
                      Passionné de vélo </br>
                      jsbw jsdw e pie  weith </br>
                      pihshe  ioihihoih !
                    </p>
                  </v-card-text>
                </v-card>
              </v-flex>-->

            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Notre promesse/Parallax ordinateur-->
    <v-container fluid class="hidden-xs-only">
      <v-parallax :src="require('../assets/veloshop.ca_champ-rues.jpg')">
        <v-layout
                align-center
                justify-center
                dark
        >
          <v-flex xs8 offset-xs-2>
            <v-card color="white">
              <v-card-title>
                <v-layout justify-center>
                  <div><h1>Notre promesse</h1></div>
                </v-layout>

              </v-card-title>
              <v-divider inset></v-divider>
              <v-card-text>
                <h3>Une shop de vélo qui vient à vous!</h3>
                <p>Nous souhaitons offrir un service mobile qui s’adapte à votre style de vie et qui vous permet
                  de toujours faire plus de vélo. Réparation et entretien de pneu, freins, dérailleurs et tout ce
                  qui a trait à votre vélo. Tous nos services pour l’entretien et la réparation de votre vélo sont
                  offerts à n’importe quel endroit. Laissez-nous savoir quels sont vos besoins, votre disponibilité,
                  votre emplacement et nous serons présents pour vos servir. Malgré la variété de nos services,
                  nous vous promettons un service de qualité et durable. De plus, nous mettons à votre disponibilité
                  un technicien qualifié qui saura répondre à vos attentes. Finalement, notre approche personnalisée
                  vous permet d’assister à la mise au point de votre vélo.
                </p>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-parallax>
    </v-container>

    <!-- Notre promesse/Parallax cellulaire -->
    <v-container
            fluid
            class="hidden-sm-and-up teal darken-4"
            height="440">

        <!--src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"-->
        <v-layout row wrap column justify-center align-center class="white--text">
          <div><h3>Notre mission</h3></div>
          <h4>Une shop de vélo qui vient à vous!</h4>
          <div>Nous souhaitons offrir un service mobile qui s’adapte à votre style de vie et qui vous permet
            de toujours faire plus de vélo. Réparation et entretien de pneu, freins, dérailleurs et tout ce
            qui a trait à votre vélo. Tous nos services pour l’entretien et la réparation de votre vélo sont
            offerts à n’importe quel endroit. Laissez-nous savoir quels sont vos besoins, votre disponibilité,
            votre emplacement et nous serons présents pour vos servir. Malgré la variété de nos services,
            nous vous promettons un service de qualité et durable. De plus, nous mettons à votre disponibilité
            un technicien qualifié qui sera répondre à vos attentes. Finalement, notre approche personnalisée
            vous permet d’assister à la mise au point de votre vélo.</div>
        </v-layout>
    </v-container>
    </br>

    <!-- Vidéo -->
    <!--<v-container fluid class="grey lighten-2">
      <v-flex>
        <video width="100%" controls>
          <source href="https://www.youtube.com/watch?v=bvNwWm11LlI&start_radio=1&list=RDbvNwWm11LlI" type="video">
        </video>
      </v-flex>
    </v-container>-->

    <!-- footer -->
    <v-layout justify-center>
      <v-flex xs12>
        <v-footer
                dark
                height="auto">
          <v-card
                  class="flex"
                  flat
                  tile>
            <v-card-title class="teal">
              <h2>SUIVEZ-NOUS!</h2>
               <v-divider light></v-divider>
              <v-btn fab light href="https://www.facebook.com/veloshop.ca/" target="_blank">
                <v-icon size="24px">fab fa-facebook</v-icon>
              </v-btn>
              <v-btn fab light href="https://www.instagram.com/veloshop.ca/?hl=en" target="_blank">
                  <v-icon size="24px">fab fa-instagram</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-actions class="grey darken-3 justify-center">
              &copy;2019 — <strong>Véloshop.ca</strong>
            </v-card-actions>

          </v-card>
        </v-footer>
      </v-flex>
    </v-layout>


  </v-container>
</template>

<script>
    export default {
        name: 'Home',
        data: () => ({

        }),

    }
</script>

<style>

  .icon-next{
    height: 130px;
  }

  .decoration {
    text-decoration: none;
  }


</style>

